import Btn from './Button';
import { useSettings } from '../../context/SettingsContext';
import en from '../../locales/en.json';
import hi from '../../locales/hi.json';
import gu from '../../locales/gu.json';

const translations = { en, hi, gu };

export default function FormActions({ children, onSave, onCancel, label, loading = false, danger = false, disabled = false, className = "", plain = false }) {
  const { language = 'en' } = useSettings();
  
  const t = (key) => {
    return translations[language]?.common?.[key] || translations.en?.common?.[key] || key;
  };

  const displayLabel = label || t("btn_save_changes");

  return (
    <div
      className={`flex gap-2 w-full ${plain ? '' : 'mt-5 pt-4 border-t border-border dark:border-slate-700'} ${className}`}
    >
      {children ? (
        children
      ) : (
        <>
          <Btn variant={danger ? "danger" : "primary"} onClick={onSave} loading={loading} disabled={disabled} full className="flex-1">{displayLabel}</Btn>
          <Btn onClick={onCancel} variant='default' disabled={loading} full className="flex-1">{t("btn_cancel")}</Btn>
        </>
      )}
    </div>
  );
}
